var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('apexchart',{attrs:{"type":"treemap","height":"400","options":_vm.data.chartOptions,"series":_vm.data.series}})}
var staticRenderFns = []

export { render, staticRenderFns }